import axiosHttp, { fetchRefreshToken } from "./axios-service";
import axios from "axios";
import { createBrowserHistory } from "history";
const history = createBrowserHistory();

const REACT_APP_BASE_API = process.env.REACT_APP_BASE_API;
const USER_LOGIN = process.env.REACT_APP_USER_LOGIN;
const REACT_APP_BASE_AUTODAILER = process.env.REACT_APP_BASE_AUTODAILER;
const REACT_APP_SDK_API = process.env.REACT_APP_SDK_API;
const REACT_SDK_API = process.env.REACT_SDK_API;
const REACT_APP_OLD_URL = process.env.REACT_APP_OLD_URL;
const REACT_APP_LOS = process.env.REACT_APP_BASE_API_LOS;

export default class OVCAPIService {
  shouldAttemptRefresh(error) {
    const status = error?.response?.status;
    return status === 401 || status === 403;
  }

  getAuthHeader(isForm = false) {
    const token = localStorage.getItem("accessToken");
    return {
      "Content-Type": isForm ? "multipart/form-data" : "application/json",
      Token: `Bearer ${token}`,
    };
  }

  getAuthHeaderCaller(isForm = false) {
    const token = localStorage.getItem("accessToken");
    return {
      "Content-Type": isForm ? "multipart/form-data" : "application/json",
      // Token: `Bearer ${token}`,
    };
  }
  getAuthNotification(isForm = false) {
    return {
      "Content-Type": "application/json",
      Authorization: "hjghfgdgstrciOiJIUzI1NiIsInR5cCI6z"
      // Token: `Bearer ${token}`,
    }
  }
  getRefreshTokenAuthHeader(isForm = false) {
    const token = localStorage.getItem("refreshToken");
    return {
      "Content-Type": isForm ? "multipart/form-data" : "application/json",
      Token: `Bearer ${token}`,
    };
  }
  async fetchRefreshToken() {
    try {
      const data = await fetchRefreshToken();
      return data;
    } catch (error) {
      localStorage.clear();
      history.push("/");
      window.location.reload();
      throw new Error("Failed to refresh token. Unable to fetch Partner List.");
    }
  }
  async fetchCustomerList(
    searchTerm = "",
    filters,
    pageNumber = 1,
    perPage = 5
  ) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/customers`;
      const payload = {
        search_text: searchTerm,
        filters: filters,
        page_number: pageNumber,
        per_page: perPage,
      };
      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchCustomerList(
            (searchTerm = ""),
            filters,
            (pageNumber = 1),
            (perPage = 5)
          );
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async fetchSanctionList(searchTerm = "", pageNumber = 1, type, partner, date) {
    try {
      let url = `${REACT_APP_BASE_API}elastic/${type}?`;
      const queryParams = [];
      if (searchTerm) {
        queryParams.push(`customer_ucic=${encodeURIComponent(searchTerm)}`);
      }
      if (type === 'secured_listing') {
        queryParams.push(`per_page=5`);
      }
      if (pageNumber) {
        type === 'secured_listing' ? queryParams.push(`page=${pageNumber}`) : queryParams.push(`page_number=${pageNumber}`);
      }
      if (partner) {
        queryParams.push(`partner=${partner}`);
      }
      if (type === 'secured_listing') {
        queryParams.push(`product=Secured Loan&status=Accepted`);

      }
      if (date) {
        const parts = date.split(" - ");
        if (parts.length === 2) {
          let startDate = parts[0].trim();
          let endDate = parts[1].trim();
          queryParams.push(`start_date=${startDate}`);
          queryParams.push(`end_date=${endDate}`);
        }
      }
      if (queryParams.length > 0) {
        url += queryParams.join("&");
      }

      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchSanctionList((pageNumber = 1));
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async fetchDashboardData(searchTerm = "", pageNumber = 1, perPage = 5) {
    try {
      let url = `${REACT_APP_BASE_API}elastic/clm/listing/?search=${searchTerm}`;
      if (pageNumber > 1) {
        url = url + "&page_number=" + pageNumber;
      }
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchDashboardData((pageNumber = 1), (perPage = 5));
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async fetchPartnerALList() {
    try {
      const url = `${REACT_APP_BASE_API}elastic/partners/partners/`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchPartnerALList();
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async fetchSettlementList(
    customer_code,
    searchTerm,
    pageNumber,
    perPage,
    startDate,
    endDate
  ) {
    try {
      const headers = this.getAuthHeader();
      let url = `${REACT_APP_BASE_API}ovc/v1/settement_list?`;

      const queryParams = [];
      if (customer_code) {
        queryParams.push(`customer_code=${customer_code}`);
      }
      if (searchTerm) {
        queryParams.push(`search=${encodeURIComponent(searchTerm)}`);
      }
      if (pageNumber) {
        queryParams.push(`current=${pageNumber}`);
      }
      if (perPage) {
        queryParams.push(`pageSize=${perPage}`);
      }
      if (startDate) {
        queryParams.push(`created_at_start=${startDate}`);
      }
      if (endDate) {
        queryParams.push(`created_at_end=${endDate}`);
      }
      if (queryParams.length > 0) {
        url += queryParams.join("&");
      }

      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchSettlementList(
            customer_code,
            searchTerm,
            pageNumber,
            perPage,
            startDate,
            endDate
          );
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }

  async fetchPaymentDetails(customer_code) {
    try {
      const url = `${REACT_APP_BASE_API}ovc/v1/payment_details?customer_code=${customer_code}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchPaymentDetails(customer_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async fetchTransactionList(
    customer_code,
    searchTerm,
    pageNumber,
    perPage,
    file,
    startDate,
    endDate,
    call_type
  ) {
    try {
      const headers = this.getAuthHeader();
      let url = `${REACT_APP_BASE_API}ovc/v1/transaction_list?`;

      const queryParams = [];
      if (customer_code) {
        queryParams.push(`customer_code=${customer_code}`);
      }
      if (searchTerm) {
        queryParams.push(`search=${encodeURIComponent(searchTerm)}`);
      }
      if (pageNumber) {
        queryParams.push(`current=${pageNumber}`);
      }
      if (perPage) {
        queryParams.push(`pageSize=${perPage}`);
      }
      if (call_type) {
        queryParams.push(`call_type=${call_type}`);
      }
      if (file) {
        queryParams.push(`data_type=${file}`);
      }
      if (startDate) {
        queryParams.push(`created_at_start=${startDate}`);
      }
      if (endDate) {
        queryParams.push(`created_at_end=${endDate}`);
      }
      if (queryParams.length > 0) {
        url += queryParams.join("&");
      }

      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchTransactionList(
            customer_code,
            searchTerm,
            pageNumber,
            perPage,
            file,
            startDate,
            endDate,
            call_type
          );
        } catch (refreshError) {
          throw refreshError;
        }
      }
      console.error("Error fetching settlement list:", error);
      throw error;
    }
  }

  async fetchBankDetails(partnerCode, partner_id) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/bank_details/${partnerCode}/${partner_id}`;
      const headers = this.getAuthHeader();

      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchBankDetails(partnerCode, partner_id);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async fetchRiskScore(partnerCode, partner_id) {
    try {
      const url = `${REACT_APP_BASE_API}risk_score/${partnerCode}/${partner_id}`;
      const headers = this.getAuthHeader();

      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchRiskScore(partnerCode, partner_id);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async fetchDocument(loanbyid) {
    try {
      const url = `${REACT_APP_BASE_API}internal/documents/${loanbyid}?call_ovc=true`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchDocument(loanbyid);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async fetchCustomerOverView(partner_code, customer_code) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/customer_overview/${partner_code}/${customer_code}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchCustomerOverView(partner_code, customer_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }

  async fetchCustomerBureauProfile(partner_code, customer_code) {
    try {
      const url = `${REACT_APP_OLD_URL}elastic/bureau_overview/${partner_code}/${customer_code}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Bureau Profile:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchCustomerBureauProfile(partner_code, customer_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }

  // loan

  async fetchPreviousLoan(partner_code, customer_code) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/previous_loans/${partner_code}/${customer_code}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchPreviousLoan(partner_code, customer_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async fetchActiveLoan(partner_code, customer_code) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/active_loan/${partner_code}/${customer_code}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchActiveLoan(partner_code, customer_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async fetchLoanDetails(loan_id) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/loan_details/${loan_id}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchLoanDetails(loan_id);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async fetchActiveHistory(partner_code, customer_code) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/activity_history/${partner_code}/${customer_code}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchActiveHistory(partner_code, customer_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async fetchEquifaxReport(partner_code, partner_id, loan_id) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/equifax_report/${partner_code}/${partner_id}/${loan_id}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchEquifaxReport(partner_code, partner_id, loan_id);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async fetchKFSLoanDetails(loan_id) {
    try {
      const url = `${REACT_APP_BASE_API}ovc/v1/loan-details?loan_uid=${loan_id}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchKFSLoanDetails(loan_id);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async fetchDeviceDetails(loan_id) {
    try {
      const url = `${REACT_APP_BASE_API}ovc/v1/fetch-devices?loan_uid=${loan_id}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchDeviceDetails(loan_id);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async fetchSanctionDetails(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/loan_details/`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchSanctionDetails(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async fetchLenderMappingdecision(requestData) {
    try {
      const url = `${REACT_APP_OLD_URL}lender/decision/update/`;
      const headers = this.getAuthHeader();
      const response = await axios.patch(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchLenderMappingdecision(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async updateLenderMultitranchAmount(requestData) {
    try {
      const url = `${REACT_APP_OLD_URL}lender/update/multitranch_amt`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.updateLenderMultitranchAmount(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async getLenderEligibilityCheck(lead_id) {
    try {
      const url = `${REACT_APP_BASE_API}lender/eligibility_check/${lead_id}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getLenderEligibilityCheck(lead_id);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getLenderMapping(lead_id) {
    try {
      const url = `${REACT_APP_OLD_URL}lender/mappings/${lead_id}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getLenderMapping(lead_id);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getSecuredLoan() {
    try {
      const url = `${REACT_APP_OLD_URL}lender/stages_substages/mapping`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getSecuredLoan();
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  //fetch/secured_loans
  async fetchSanctionLoanDetails(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/sanction/loan_details`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchSanctionLoanDetails(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async fetchDeviceDetails(loan_id) {
    try {
      const url = `${REACT_APP_BASE_API}ovc/v1/fetch-devices?loan_uid=${loan_id}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchDeviceDetails(loan_id);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async saveCustomersDetails(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/sanction/update_kyc`;
      const headers = this.getAuthHeader();
      const response = await axios.patch(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.saveCustomersDetails(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async fetchSecureLoan(partner_code, customer_code) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/secured_loan/details?applicant_id=${customer_code}--${partner_code}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchSecureLoan(partner_code, customer_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }

  async saveDistributorDetail(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/create/distributor`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.saveDistributorDetail(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }

  async saveDematDetails(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/create/offering`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.saveDistributorDetail(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }

  async saveSurveyDetail(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/create/survey`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.saveSurveyDetail(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      console.error("Error Fetching Sanction Details:", error);
      throw error;
    }
  }

  async saveCallRemark(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/create/call_remarks`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.saveCallRemark(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async saveStoreRemark(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/store/remarks`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.saveStoreRemark(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      console.error("Error Fetching Sanction Details:", error);
      throw error;
    }
  }
  async getTaskData(customer_code) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/fetch_task/${customer_code}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getTaskData(customer_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async getIMEI(customer_code, partner_code) {
    try {
      const url = `${REACT_APP_BASE_API}fetch/branch_device/${partner_code}/${customer_code}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getIMEI(customer_code, partner_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }

  async sendOfferLink(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/send_offer_link`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.sendOfferLink(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }

  async storeRemarks(payload) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/store/remarks`;
      const headers = this.getAuthHeader();
      const response = await axios.patch(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.storeRemarks(payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async updatePaymintDeviceList(payload) {
    try {
      const url = `${REACT_APP_BASE_API}update_paymint_device`;
      const headers = this.getAuthHeader();
      const response = await axios.patch(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.updatePaymintDeviceList(payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }

  async verifyLoanStatus(kyc_payload) {
    try {
      const url = `${REACT_APP_BASE_API}loans/update_status`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, kyc_payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.verifyLoanStatus(kyc_payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async resumeLoanStatus(kyc_payload) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/revert/sanction_hold`;
      const headers = this.getAuthHeader();
      const response = await axios.patch(url, kyc_payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.resumeLoanStatus(kyc_payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async sendUdyamLink(payload) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/send_udyam_install_link`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.sendUdyamLink(payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async sendCustomermsg(payload) {
    try {
      const url = `${REACT_APP_BASE_API}trigger_customer_msg/`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.sendCustomermsg(payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async uploadFile(formData) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/sanction/uploads`;
      const headers = this.getAuthHeader(true);
      const response = await axios.post(url, formData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.uploadFile(formData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async fetchTicketManagementList(
    selectedTicketType,
    selectedPriority,
    selectedStatus,
    value,
    customerDatePayload,
    role,
    currentPage,
    perPage,
    created_by
  ) {
    try {
      const headers = this.getAuthHeader();
      const params = new URLSearchParams();

      if (customerDatePayload) {
        params.append("start_date", customerDatePayload[0]);
        params.append("end_date", customerDatePayload[1]);
      }
      if (value) params.append("search", value);
      if (currentPage) params.append("page_number", currentPage);
      if (perPage) params.append("per_page", perPage);
      if (role) params.append("role", role);
      if (created_by) params.append("email", created_by);
      if (selectedPriority) params.append("priority", selectedPriority);
      if (selectedTicketType) params.append("ticket_type", selectedTicketType);
      if (selectedStatus) params.append("status", selectedStatus);

      const url = `${REACT_APP_BASE_API}ticket/list?${params.toString()}`;
      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Ticket List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchTicketManagementList(
            selectedTicketType,
            selectedPriority,
            selectedStatus,
            value,
            customerDatePayload,
            role,
            currentPage,
            perPage,
            created_by
          );
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async updateTicket(payload) {
    try {
      const url = `${REACT_APP_BASE_API}ticket/update`;
      const headers = this.getAuthHeader(true);
      const response = await axios.patch(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.updateTicket(payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async getAssigneeList() {
    try {
      const url = `${REACT_APP_BASE_API}ticket/assignee_list`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getAssigneeList();
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async getFetchCustomerList(type, Id) {
    try {
      const params_type = type === "loanUID" ? "loan_uid" : "customer_code";
      const url = `${REACT_APP_BASE_API}ticket/fetch_customer?${params_type}=${Id}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getFetchCustomerList(Id);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getFetchticketovchistory(customer_code, currentPage) {
    try {
      const url = `${REACT_APP_BASE_API}ticket/fetch/${customer_code}?per_page=${5}&page_number=${currentPage}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getFetchticketovchistory(customer_code, currentPage);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async createTicket(payload) {
    try {
      const url = `${REACT_APP_BASE_API}ticket/create`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else {
        // try {
        //   await this.fetchRefreshToken();
        //   return this.createTicket(payload);
        // } catch (refreshError) {
        //   throw refreshError;
        // }
      }

      throw error;
    }
  }
  async mergeTickets(payload) {
    try {
      const url = `${REACT_APP_BASE_API}ticket/merge`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Merging Tickets:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.mergeTickets(payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async getAutoDialerCaller(agent_id, customer_number) {
    try {
      const url = `${REACT_APP_BASE_AUTODAILER}click2call/click2call.php?internalnum=${agent_id}&outboundnum=${customer_number}`;
      const headers = this.getAuthHeaderCaller();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      //  if (error?.response?.data) {
      //   console.error("Error Fetching Partner List:", error);
      //  } else {
      //   // this.fetchRefreshToken()
      //  }

      throw error;
    }
  }
  async callIntitated(payload) {
    try {
      const url = `${REACT_APP_BASE_API}ovc/v1/create/call_events`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.callIntitated(payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async callDispoition(payload) {
    try {
      const url = `${REACT_APP_BASE_API}ovc/v1/disposition`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.callDispoition(payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getFetchagent(email_id, role) {
    try {
      const url = `${REACT_APP_BASE_API}ovc/v1/fetch_agent?user_email=${encodeURI(email_id)}&role_name=${role}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getFetchagent(email_id);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async fetchCallerList(
    value, role, agent_id, currentPage, perPage, startDate, endDate, statusSelected, callerStatus, customer_code, moduletype, selectedCampings, selectedModuleType, selectedagentId,
    selectedDisposition
  ) {
    try {

      const headers = this.getAuthHeader();
      const baseUrl = `${REACT_APP_BASE_API}ovc/v1/call_details`;

      const params = new URLSearchParams();
      if (statusSelected !== "") {
        params.append("call_type", statusSelected);
      } if (callerStatus !== "") {
        params.append("status", callerStatus?.value);
      }
      if (value) params.append("search_text", value);
      if (endDate !== "" && startDate !== "") {
        params.append("start_date", startDate);
        params.append("end_date", endDate);
      }
      if (selectedCampings) params.append("compaign_name", selectedCampings?.join(","));
      if (selectedDisposition && selectedCampings?.length === 1) params.append("disposition", selectedDisposition?.join(","));
      if (selectedagentId && role === "ADMIN") params.append("agent_id", selectedagentId?.join(","));
      if (role) params.append("role", role);
      if (agent_id && role !== "ADMIN") params.append("agent_id", agent_id);
      if (customer_code) params.append("customer_code", customer_code);
      if (moduletype) params.append("module_type", moduletype);
      if (selectedModuleType && role === "ADMIN") params.append("module_type", selectedModuleType?.value);
      if (currentPage) params.append("page_number", currentPage);
      if (perPage) params.append("per_page", perPage);

      const url = `${baseUrl}?${params.toString()}`;
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchCallerList(
            value,
            role,
            agent_id,
            currentPage,
            perPage, startDate, endDate, statusSelected, callerStatus, customer_code, moduletype, selectedCampings, selectedModuleType, selectedagentId, selectedDisposition
          );
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async fetch_disposition(caller_id) {
    try {
      const url = `${REACT_APP_BASE_API}ovc/v1/fetch_disposition?caller_id=${caller_id}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetch_disposition(caller_id);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getTicketConstants() {
    try {
      let url = `${REACT_APP_BASE_API}ticket/constants`;
      const headers = this.getAuthHeader(true);
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Counts:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getTicketConstants();
        } catch (refreshError) {
          throw refreshError;
        }
      }
    }
  }
  async getCounts(lender, startDate, endDate) {
    try {
      let url = `${REACT_APP_BASE_API}elastic/secured_loans/stages/counts/`;
      const params = {};

      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;
      if (lender) params.lender_code = lender;

      // if (lender != "All") {
      //   url += `?lender_code=${lender}`;
      // }
      const headers = this.getAuthHeader(true);
      const response = await axios.get(url, { headers, params });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Counts:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getCounts(lender);
        } catch (refreshError) {
          throw refreshError;
        }
      }
    }
  }
  async getScheduleData(customer_code) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/fetch_schedule_time/?customer_code=${customer_code}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getScheduleData(customer_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async saveSchedule(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/appointments/create`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.saveSchedule(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async saveBlacklist(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/update_blacklist`;
      const headers = this.getAuthHeader();
      const response = await axios.patch(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.saveBlacklist(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async fetchDisposition(customer_code, pageNumber, perPage) {
    try {
      let baseUrl = `${REACT_APP_BASE_API}elastic/disposition_data?`;

      const queryParams = [];
      if (customer_code) queryParams.push(`customer_code=${customer_code}`);
      if (pageNumber) queryParams.push(`page=${pageNumber}`);
      if (perPage) queryParams.push(`per_page=${perPage}`);

      const url = queryParams.length > 0 ? `${baseUrl}${queryParams.join("&")}` : baseUrl;

      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchDisposition(customer_code, pageNumber, perPage);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async sentnotificationData() {
    try {
      const url = `${REACT_APP_LOS}unified/api/notifications/`;
      const headers = this.getAuthNotification();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else {
        //  try {
        //   await this.fetchRefreshToken();
        //   return this.sentnotificationData();
        // } catch (refreshError) {
        //   throw refreshError;
        // }
      }
      throw error;
    }
  }
  async fetchCustomerRepayment(customer_code, partner_code) {
    try {
      let baseUrl = `${REACT_APP_BASE_API}elastic/customer_repayments/${partner_code}/${customer_code}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(baseUrl, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchCustomerRepayment(customer_code, partner_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async SecureverifyLoanStatus(kyc_payload) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/secured_loans/update`;
      const headers = this.getAuthHeader();
      const response = await axios.patch(url, kyc_payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.SecureverifyLoanStatus(kyc_payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async getdispositionList(role) {
    try {
      const url = `${REACT_APP_BASE_API}ovc/v1/compaign/disposition?role_name=${role}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getdispositionList(role);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getsahyogList(start_date, end_date, search, status, currentPage, perpage) {
    try {
      const url = `${REACT_APP_BASE_API}sahiyog/list`;
      const headers = this.getAuthHeader();

      // Setup query parameters
      const params = {};

      if (start_date) params.start_date = start_date;
      if (end_date) params.end_date = end_date;
      if (status) params.status = status?.value;
      if (search) params.search = search;
      if (currentPage) params.page = currentPage;
      if (perpage) params.per_page = perpage;

      const response = await axios.get(url, { headers, params });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Sahyog List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getsahyogList(start_date, end_date, status, search, currentPage, perpage);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async getsahyogDetails(id) {
    try {
      const url = `${REACT_APP_BASE_API}sahiyog/list?id=${id}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else {
        try {
          // await this.fetchRefreshToken();
          // return this.getsahyogList(start_date, end_date, status, search, currentPage, perpage);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async UpdatedSahyogData(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}sahiyog/update`;
      const headers = this.getAuthHeader(true);
      const response = await axios.patch(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.UpdatedSahyogData(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async uploadFilesahyog(formData) {
    try {
      const url = `${REACT_APP_BASE_API}sahiyog/upload_documents`;
      const headers = this.getAuthHeader(true);
      const response = await axios.post(url, formData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.uploadFile(formData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getBusinessCustomerList(search, start_date, end_date, currentPage, perpage, FullPayment, LoginFees, OfferingType) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/business_prime_list`;
      const headers = this.getAuthHeader();

      // Setup query parameters
      const params = {};

      if (start_date) params.start_date = start_date;
      if (end_date) params.end_date = end_date;
      if (FullPayment) params.payment = FullPayment === "Full Payment" ? "full_payment" : "partially_payment";
      if (LoginFees) params.bp_opted = LoginFees;
      if (OfferingType) params.offering_type = OfferingType;
      if (search) params.search = search;
      if (currentPage) params.page_number = currentPage;
      if (perpage) params.per_page = perpage;

      const response = await axios.get(url, { headers, params });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Business Prime List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getBusinessCustomerList(search, start_date, end_date, currentPage, perpage, FullPayment, LoginFees, OfferingType);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getDeviceInventry(start_date, end_date, search, currentPage, perpage, branchList, offeringType, statusSelected) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/device_inventry`;
      const headers = this.getAuthHeader();

      // Setup query parameters
      const params = {};

      if (start_date) params.start_date = start_date;
      if (end_date) params.end_date = end_date;
      if (branchList) params.center = branchList;
      if (statusSelected) params.status = statusSelected;
      if (offeringType) params.offering_type = offeringType;
      if (search) params.search = search;
      if (currentPage) params.page_number = currentPage;
      if (perpage) params.per_page = perpage;

      const response = await axios.get(url, { headers, params });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getDeviceInventry(start_date, end_date, search, currentPage, perpage, branchList, offeringType);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;

    }
  }
  async getInsuranceList(search, start_date, end_date, currentPage, perpage) {
    try {
      const url = `${REACT_APP_BASE_API}ovs/v1/insurance/list`;
      const headers = this.getAuthHeader();

      const params = new URLSearchParams();

      if (start_date) params.append("start_date", start_date);
      if (end_date) params.append("end_date", end_date);
      // if (status) params.append("status", status);
      if (search) params.append("search", search);
      if (currentPage) params.append("page_number", currentPage);
      if (perpage) params.append("per_page", perpage);

      const response = await axios.get(`${url}?${params.toString()}`, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Insurance List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getInsuranceList(search, start_date, end_date, currentPage, perpage);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async CreatePaymentLink(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}create_bp_payment_link`;
      const headers = this.getAuthHeader(false);
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.CreatePaymentLink(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }


  async getGeneratePayment(customer_code) {
    try {
      const url = `${REACT_APP_BASE_API}fetch_bp_payment_link?customer_code=${customer_code}`;
      const headers = this.getAuthHeader();

      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getGeneratePayment(customer_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async UpdatedClaims(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}ovs/v1/insurance/actions`;
      const headers = this.getAuthHeader(true);
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.UpdatedClaims(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getCenterList() {
    try {
      const url = `${REACT_APP_BASE_API}fetch_centers`;
      const headers = this.getAuthHeader();

      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getCenterList();
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getBusinessPrimeDashboard(start_date, end_date, branchList) {

    try {
      const url = `${REACT_APP_BASE_API}elastic/business_prime`;
      const headers = this.getAuthHeader();

      // Setup query parameters
      const params = {};

      if (start_date) params.start_date = start_date;
      if (end_date) params.end_date = end_date;
      if (branchList) params.branch = branchList?.value;
      // if (search) params.search = search;

      const response = await axios.get(url, { headers, params });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getDeviceInventry(start_date, end_date, branchList);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async updateBusinessPrimeDevice(payload) {
    try {
      const url = `${REACT_APP_BASE_API}update/business_prime_device`;
      const headers = this.getAuthHeader();
      const response = await axios.patch(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.updateBusinessPrimeDevice(payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async getinsuranceDetails(id) {
    try {
      const url = `${REACT_APP_BASE_API}ovs/v1/insurance/show/${id}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else {
        try {
          // await this.fetchRefreshToken();
          // return this.getsahyogList(start_date, end_date, status, search, currentPage, perpage);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getcollectionList(search, start_date, end_date, currentPage, perpage, branchList, dpdList, key, value, category, partner, module_type) {
    try {
      const url = `${REACT_APP_BASE_API}ovs/v1/collections/list`;
      const headers = this.getAuthHeader();

      const params = {};

      if (start_date) params.start_date = start_date;
      if (end_date) params.end_date = end_date;
      if (branchList) params.branch_id = branchList;
      if (dpdList) params.dpd_bucket = dpdList?.join(",");
      if (search) params.search = search;
      if (key) params.sort_by = key
      if (value) params.sort_order = value
      if (category) params.category = category;
      if (partner) params.partner = partner;
      if (module_type) params.module_type = module_type;
      if (currentPage) params.page_number = currentPage;
      if (perpage) params.per_page = perpage;

      const response = await axios.get(url, { headers, params });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getcollectionList(start_date, end_date, search, currentPage, perpage, branchList, dpdList, key, value);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async CreateCollectionPaymentLink(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}create_payment_link`;
      const headers = this.getAuthHeader(false);
      const response = await axios.post(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.CreateCollectionPaymentLink(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getFetchGenerateLink(loan_uid) {
    try {
      const url = `${REACT_APP_BASE_API}fetch_payment_link?loan_uid=${loan_uid}`;
      const headers = this.getAuthHeader();

      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getFetchGenerateLink(loan_uid);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getFetchCallerDisposition(customer_code) {
    try {
      const url = `${REACT_APP_BASE_API}ovs/v1/collections/calls?customer_code=${customer_code}`;
      const headers = this.getAuthHeader();

      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getFetchGenerateLink(customer_code);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async fetchCenterList() {
    try {
      const url = `${REACT_APP_BASE_API}ovs/v1/branches/list`;
      const headers = this.getAuthHeader();

      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchCenterList();
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async fetchLoanCard(loan_uid) {
    try {
      const url = `${REACT_APP_BASE_API}ovs/v1/loan_cards/${loan_uid}`;
      const headers = this.getAuthHeader();

      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchLoanCard(loan_uid);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getInsuranceDashboard(start_date, end_date) {
    try {
      const url = `${REACT_APP_BASE_API}ovs/v1/insurance/dashboard`;
      const headers = this.getAuthHeader();

      const params = {};

      if (start_date) params.start_date = start_date;
      if (end_date) params.end_date = end_date;
      const response = await axios.get(url, { headers, params });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getInsuranceDashboard(start_date, end_date);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getWaiveOffAmount(loan_uid) {
    try {
      const url = `${REACT_APP_BASE_API}ovs/v1/waive_off_amount/${loan_uid}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getWaiveOffAmount(loan_uid);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getSahyogDashboard(start_date, end_date) {
    try {
      const url = `${REACT_APP_BASE_API}sahiyog/dashboard_data`;
      const headers = this.getAuthHeader();

      const params = {};

      if (start_date) params.from_date = start_date;
      if (end_date) params.to_date = end_date;
      const response = await axios.get(url, { headers, params });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getSahyogDashboard(start_date, end_date);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async getRepeatList(search, start_date, end_date, currentPage, perpage, branchList, dpdList, key, value) {
    try {
      const url = `${REACT_APP_BASE_API}ovs/v1/sales/repeat_data`;
      const headers = this.getAuthHeader();

      const params = {};

      if (start_date) params.start_date = start_date;
      if (end_date) params.end_date = end_date;
      if (branchList) params.branch_id = branchList;
      if (dpdList) params.dpd_bucket = dpdList;
      if (search) params.search = search;
      if (key) params.sort_by = key
      if (value) params.sort_order = value
      params.module_type = "sales_repeat";
      if (currentPage) params.page_number = currentPage;
      if (perpage) params.per_page = perpage;

      const response = await axios.get(url, { headers, params });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getRepeatList(start_date, end_date, search, currentPage, perpage, branchList, dpdList, key, value);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getHotLeadList(search, start_date, end_date, currentPage, perpage, branchList, dpdList, key, value) {
    try {
      const url = `${REACT_APP_BASE_API}ovs/v1/sales/hotlead`;
      const headers = this.getAuthHeader();

      const params = {};

      if (start_date) params.start_date = start_date;
      if (end_date) params.end_date = end_date;
      if (branchList) params.branch_id = branchList;
      if (dpdList) params.dpd_bucket = dpdList;
      if (search) params.search = search;
      if (key) params.sort_by = key
      if (value) params.sort_order = value
      params.module_type = "digital_hunting";
      if (currentPage) params.page_number = currentPage;
      if (perpage) params.per_page = perpage;

      const response = await axios.get(url, { headers, params });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else {
        try {
          // await this.fetchRefreshToken();
          // return this.getHotLeadList(start_date, end_date, search, currentPage, perpage, branchList, dpdList,key, value);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getCustomerInterestList(
    search,
    start_date,
    end_date,
    currentPage,
    perpage,
    branchList
  ) {
    try {
      const baseUrl = `${REACT_APP_BASE_API}elastic/sanction/all_customer`;
      const headers = this.getAuthHeader();

      const params = new URLSearchParams();
      params.append("module_type", "welcome_call");

      if (start_date) params.append("start_date", start_date);
      if (end_date) params.append("end_date", end_date);
      if (branchList) params.append("branch_id", branchList);
      if (search) params.append("search", search);
      if (currentPage) params.append("page_number", currentPage);
      if (perpage) params.append("per_page", perpage);

      const url = `${baseUrl}?${params.toString()}`;

      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getCustomerInterestList(
            search,
            start_date,
            end_date,
            currentPage,
            perpage,
            branchList
          );
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getAgentName() {
    try {
      const url = `${REACT_APP_BASE_API}ovc/v1/agents`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getAgentName();
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async skipTracing(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}skip_tracing/update_data`;
      const headers = this.getAuthHeader();
      const response = await axios.patch(url, requestData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.skipTracing(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getSkipTracking(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}skip_tracing/fetch_skip_tracing`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getSkipTracking(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async createRuleData(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}ticket/rule_creation`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.createRuleData(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async createUserManagement(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}ticket/assignees`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, requestData, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.createUserManagement(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getTicketAssignneList(
    currentPage,
    perpage,
  ) {
    try {
      const baseUrl = `${REACT_APP_BASE_API}ticket/assignee_list`;
      const headers = this.getAuthHeader();

      const params = new URLSearchParams();
      if (currentPage) params.append("page_number", currentPage);
      if (perpage) params.append("per_page", perpage);

      const url = `${baseUrl}?${params.toString()}`;

      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getTicketAssignneList(
            currentPage,
            perpage,
          );
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async fetchUploadList(
    searchTerm = "",
    pageNumber = 1,
    perPage = 10
  ) {
    try {
      const url = `${REACT_APP_BASE_API}admin/uploads/list`;
      const payload = {
        search_text: searchTerm,
        // filters: filters,
        fileType: ["InsurancePolicies", "InsuranceClaim"],
        page_number: pageNumber,
        per_page: perPage,
      };
      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchUploadList(
            searchTerm = "",
            pageNumber = 1,
            perPage = 10
          );
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async fetchUploadData(
    payload
  ) {
    try {
      const url = `${REACT_APP_BASE_API}admin/uploads`;

      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchUploadData(
            payload
          );
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async uploadBusinessPrimeBulkFiles(files) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/offers/bulk_upsert`;
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("file", file);
      });
      formData.append("log_prefix", "bulk-upsert");
      const headers = this.getAuthHeader(true);
      const response = await axios.post(url, formData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Uploading Business Prime Bulk Files:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.uploadBusinessPrimeBulkFiles(files);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }

  async downloadBusinessPrimeBulkSample(format = "xlsx") {
    try {
      const url = `${REACT_APP_BASE_API}elastic/offers/bulk_upsert/sample`;
      const headers = {
        Token: `Bearer ${localStorage.getItem("accessToken")}`,
      };
      const response = await axios.get(url, {
        headers,
        params: { format },
        responseType: "blob",
      });
      return response;
    } catch (error) {
      if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.downloadBusinessPrimeBulkSample(format);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
  async getTicketDashboard(start_date, end_date) {
    try {
      const url = `${REACT_APP_BASE_API}ticket/dashboard`;
      const headers = this.getAuthHeader();

      const params = {};

      if (start_date) params.from_date = start_date;
      if (end_date) params.to_date = end_date;
      const response = await axios.get(url, { headers, params });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getTicketDashboard(start_date, end_date);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async fetchMissedCallerList(
    value,
    role,
    currentPage,
    perPage, startDate, endDate
  ) {
    try {

      const headers = this.getAuthHeader();
      const baseUrl = `${REACT_APP_BASE_API}ovc/v1/call_details`;

      const params = new URLSearchParams();
      if (value) params.append("search_text", value);
      params.append("call_type", "abondon");
      if (endDate !== "" && startDate !== "") {
        params.append("start_date", startDate);
        params.append("end_date", endDate);
      }
      // if (role) params.append("role", role);
      if (currentPage) params.append("page_number", currentPage);
      if (perPage) params.append("per_page", perPage);

      const url = `${baseUrl}?${params.toString()}`;

      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchMissedCallerList(
            value,
            role,
            currentPage,
            perPage, startDate, endDate
          );
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getLoanGeneratePayment(loanUid) {
    try {
      const url = `${REACT_APP_BASE_API}fetch_payment_link?loan_uid=${loanUid}`;
      const headers = this.getAuthHeader();

      const response = await axios.get(url, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getLoanGeneratePayment(loanUid);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async getCetList(currentPage, perPage, moduletype) {
    try {
      const url = `${REACT_APP_BASE_API}ovs/v1/cet/list`;
      const headers = this.getAuthHeader();
      const params = {};
      if (moduletype) params.module_type = moduletype;
      if (currentPage) params.page_number = currentPage;
      if (perPage) params.per_page = perPage;

      const response = await axios.get(url, { headers, params });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getCetList(currentPage, perPage, moduletype);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }
  async fetchEmailThread(ticketId) {
    try {
      let url;
      if (process.env.REACT_APP_BASE_URI === "true") {
        url = `https://athos-api.arthapp.in/ticket/fetch_email_thread/${ticketId}`;
      } else {
        url = `${REACT_APP_BASE_API}ticket/fetch_email_thread/${ticketId}`;
      }
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchEmailThread(ticketId);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async sendEmailReply(payload, content, reply_type, ticketId, attachments) {
    try {
      const url = `${REACT_APP_BASE_API}ticket/email_reply/${ticketId}`;
      payload.comment = content;
      payload.reply_type = reply_type;
      payload.attachments = attachments
      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async createComment(content, ticketId, email) {
    try {
      const url = `${REACT_APP_BASE_API}ticket/comments/${ticketId}`;
      const payload = {}
      payload.content = content;
      payload.email = email;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async fetchComments(ticketId) {
    try {
      const url = `${REACT_APP_BASE_API}ticket/comments/${ticketId}`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async downloadTickets(
    selectedTicketType,
    selectedPriority,
    selectedStatus,
    value,
    customerDatePayload,
    role,
    emailId
  ) {
    try {
      const url = `${REACT_APP_BASE_API}ticket/download`;
      // const params = new URLSearchParams();
      const params = {
        ticket_type: selectedTicketType,
        priority: selectedPriority,
        status: selectedStatus,
        search_text: value,
        customer_date: customerDatePayload,
        role: role,
        email: emailId
      }
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers, params });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // searchData,
  // statusSelected,
  // callerStatus,
  // startDate,
  // endDate,
  // currentPage,
  // perPage,
  // agentId,
  // moduleType,
  // selectedCampings,
  // selectedModuleType,
  // selectedagentId,
  // selectedDisposition

  async downloadCallDetails(
    value, role, startDate, endDate, statusSelected, callerStatus, moduletype, selectedCampings, selectedModuleType, selectedagentId, selectedDisposition
  ) {
    try {
      const url = `${REACT_APP_BASE_API}ovc/v1/call_details/download`;
      const params = new URLSearchParams();
      if (statusSelected !== "") {
        params.append("call_type", statusSelected);
      } if (callerStatus !== "") {
        params.append("status", callerStatus?.value);
      }
      if (value) params.append("search_text", value);
      if (endDate !== "" && startDate !== "") {
        params.append("start_date", startDate);
        params.append("end_date", endDate);
      }
      if (selectedCampings) params.append("compaign_name", selectedCampings?.join(","));
      if (selectedDisposition && selectedCampings?.length === 1) params.append("disposition", selectedDisposition?.join(","));
      if (selectedagentId && role === "ADMIN") params.append("agent_id", selectedagentId?.join(","));
      if (role) params.append("role", role);
      // if (agent_id && role !== "ADMIN") params.append("agent_id", agent_id);
      // if (customer_code) params.append("customer_code", customer_code);
      if (moduletype) params.append("module_type", moduletype);
      if (selectedModuleType && role === "ADMIN") params.append("module_type", selectedModuleType?.value);
      // if (currentPage) params.append("page_number", currentPage);
      // if (perPage) params.append("per_page", perPage);
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers, params });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async uploadSanctinLetter(formData) {
    try {
      const url = `${REACT_APP_BASE_API}/lender/upload_agreements`;
      const headers = this.getAuthHeader(true);
      const response = await axios.post(url, formData, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.uploadSanctinLetter(formData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async fetchDigitalLeads(status, page = 1) {
    const url = `${REACT_APP_OLD_URL}ovs/v1/arth_digital_leadgen/list`;
    try {
      const params = new URLSearchParams()
      params.append("lead_status", status)
      params.append("page", page)
      params.append("per_page", 5)
      const response = await fetch(`${url}?${params.toString()}`)
      const data = await response.json()
      return data;
    } catch (error) {
      console.error("Error fetching leads:", error)
    } finally {
    }
  }

  async fetchDigitalLeadsDetails(id, mobile) {
    const url = `${REACT_APP_OLD_URL}ovs/v1/lead_gen_details?mobile=${mobile}&id=${id}`;
    try {
      const response = await fetch(`${url}`)
      const data = await response.json()
      return data;
    } catch (error) {
      console.error("Error fetching leads:", error)
    } finally {
    }
  }


  async checkLeadEligibility(payload) {
    try {
      const url = `${REACT_APP_OLD_URL}ovs/v1/lead_gen/eligibility_check`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Checking Eligibility: ", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.checkLeadEligibility(payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }


  async fetchBureauDetails(id, type) {
    try {
      let url = `${REACT_APP_BASE_API}ovs/v1/fetch/bureau_report`;
      const headers = this.getAuthHeader();
      const params = {};
      params.id = id;
      params.lead_type = type;
      const response = await axios.get(url, { headers, params });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching CAF Section Data:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchBureauDetails(id, type);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }

  async updateLeadStatus(payload) {
    try {
      const url = `${REACT_APP_BASE_API}/ovs/v1/digital_leadgen/decision`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, payload, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Partner List:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.updateLeadStatus(payload);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async updateLeadData(requestData) {
    try {
      const url = `${REACT_APP_BASE_API}/ovs/v1/update/lead`;
      const headers = this.getAuthHeader();
      const response = await axios.patch(url, requestData, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.updateLeadData(requestData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }

  async updateDispositionData(postData) {
    try {
      const url = `${REACT_APP_BASE_API}/ovc/v1/disposition`;
      const headers = this.getAuthHeader();
      const response = await axios.post(url, postData, { headers });

      return response.data;
    } catch (error) {
      if (error?.response?.data) {

      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.updateDispositionData(postData);
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }


  async fetchDigitalLeadList() {
    try {

      const headers = this.getAuthHeader();
      const baseUrl = `${REACT_APP_BASE_API}/ovs/v1/digital_leadgen/dashboard`;

      const response = await axios.get(baseUrl, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchDigitalLeadList()
        } catch (refreshError) {
          throw refreshError;
        }
      }

      throw error;
    }
  }


  async getCAFSectionData(id = 4552, section) {
    try {
      let url = `${REACT_APP_LOS}unified/v3/customer-onboard/${id}/${section}/digital_leadgen`;
      const headers = this.getAuthHeader();
      const response = await axios.get(url, { headers });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching CAF Section Data:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.getCAFSectionData(id, section);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }


  async fetchCustomerServices(customer_ucic) {
    try {
      const url = `${REACT_APP_BASE_API}elastic/fetch/customer_services`;
      const headers = this.getAuthHeader();
      const params = {
        customer_ucic,
        log_prefix: "fetch-customer-services",
      };
      const response = await axios.get(url, { headers, params });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        console.error("Error Fetching Customer Services:", error);
      } else if (this.shouldAttemptRefresh(error)) {
        try {
          await this.fetchRefreshToken();
          return this.fetchCustomerServices(customer_ucic);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  }
}
